export const getModifiedScripts = (scripts: string): string => {
	// we have to remove these statements from inDesign generated script for enabling text selection in buttons
	const eventStatementsToReplace = 'event\\.stopPropagation\\(\\);|event\\.preventDefault\\(\\);';
	const eventStatementsRegExp = new RegExp(eventStatementsToReplace, 'g');

	// tslint:disable-next-line: max-line-length
	// Some methods in inDesign generated script (e.g., handleAnimationInMSOState) get className property for each element inside MSO including elements which are added in Editor like action buttons. These buttons have svg icons inside. The className property on an svg element returns an object, not a string as for any html element. So calling indexOf on this object breaks inDesign script. The solution is to exclude <svg> and <use> elements.
	const selectorStatementsToReplace = `getElementsByTagName\\(\\'\\*\\'\\);`;
	const selectorStatementsRegExp = new RegExp(selectorStatementsToReplace, 'g');

	return scripts
		.replace(eventStatementsRegExp, '')
		.replace(selectorStatementsRegExp, `querySelectorAll('*:not(svg):not(use)');`);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/scripts.ts